var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.57 8.44 8.1 4.67l.63.41L6.2 8.86zm.95.63 2.51-3.78.63.42L7.14 9.5zm.94.62 2.51-3.77.63.42-2.52 3.77zm15.19 7.18 1.15-1.73.63.42-1.15 1.73zm-1.36 2.04 1.15-1.72.63.42-1.16 1.72zm.41-2.67 1.16-1.73.62.42-1.15 1.73zm-1.36 2.05 1.15-1.73.63.42-1.15 1.73zm.42-2.67 1.15-1.73.63.42-1.15 1.72zm-1.36 2.04 1.15-1.73.63.42-1.15 1.72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#be3b3e",
    d: "M11.23 9.49a4.53 4.53 0 1 1 7.54 5.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c449c",
    d: "M11.23 9.49a4.53 4.53 0 1 0 7.54 5.03A2.27 2.27 0 0 0 15 12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#be3b3e",
    d: "M13.11 8.48a2.27 2.27 0 1 0 0 4.53 2.27 2.27 0 0 0 0-4.53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m5.57 15.56.63-.42 2.51 3.77-.62.43zm1.89-1.25.63-.42 2.51 3.77-.63.42zm12.88-8.6.63-.42 2.52 3.78-.63.42zM6.51 14.93l.63-.42 1.15 1.73-.62.42zm1.37 2.05.62-.42 1.16 1.73-.63.41zM19.4 6.34l.63-.42 1.15 1.73-.63.42zm1.36 2.05.63-.42 1.15 1.72-.62.42zm.53-3.3.62-.42 1.16 1.72-.63.42zm1.36 2.04.63-.42 1.15 1.73-.63.42z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 1H4a3 3 0 0 0-3 3v1a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3V4a3 3 0 0 0-3-3",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/south-korea.427ba8dee1c92500c6b6dcecb6e2179e.svg";
export { ForwardRef as ReactComponent };